const JWT_KEY = 'SL_ZENDESK_JWT';
const FINGERPRINT_KEY = 'sl_zendesk_unique_id';

export const DEVICE_NAME = 'ZendeskApp';

export const getStoredJwt = (): string => localStorage.getItem(JWT_KEY) || '';

export const setStoredJwt = (jwt: string): void => {
  localStorage.setItem(JWT_KEY, jwt);
};

export const clearStoredJwt = (): void => {
  localStorage.removeItem(JWT_KEY);
};

export const getStoredFingerprint = (): string => localStorage.getItem(FINGERPRINT_KEY) || '';

export const setStoredFingerprint = (uniqueId: string): void => {
  localStorage.setItem(FINGERPRINT_KEY, uniqueId);
};
